/**
 * Route for `flat-fee-percentage-fixed-commission-payouts-per-influencer`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { FlatFeePercentageFixedCommissionPayoutsPerInfluencerPage } from "../features/flat-fee-percentage-fixed-commission-payouts-per-influencer/FlatFeePercentageFixedCommissionPayoutsPerInfluencerPage";

export const flatFeePercentageFixedCommissionPayoutsPerInfluencerRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/flat-fee-percentage-fixed-commission-payouts-per-influencer",
	component: FlatFeePercentageFixedCommissionPayoutsPerInfluencerPage,
});

export default flatFeePercentageFixedCommissionPayoutsPerInfluencerRoute;
